import React, { useMemo } from 'react';
import OptimizedChart from '../utils/OptimizedChart';
import { useApexTheme } from '../utils/apexTheme';

const DailyReturnsChart = ({ returnsSeries, height = 250 }) => {
  const { colors } = useApexTheme();

  const { componentOptions, series } = useMemo(() => {
    if (!returnsSeries || returnsSeries.length === 0) return { componentOptions: null, series: [] };

    const data = returnsSeries.map(item => ({
      x: new Date(item.timestamp).getTime(),
      y: item.return * 100,
      fillColor: item.return >= 0 ? (colors.success || '#4caf50') : (colors.error || '#f44336')
    }));

    const options = {
      chart: {
        type: 'bar',
        height,
        toolbar: {
          show: false
        },
        zoom: {
          enabled: true
        }
      },
      plotOptions: {
        bar: {
          borderRadius: 2,
          columnWidth: '80%',
          distributed: true
        }
      },
      dataLabels: {
        enabled: false
      },
      colors: data.map(d => d.fillColor),
      legend: {
        show: false
      },
      xaxis: {
        type: 'datetime',
        labels: {
          datetimeFormatter: {
            year: 'yyyy',
            month: "MMM 'yy",
            day: 'dd MMM'
          }
        }
      },
      yaxis: {
        title: {
          text: 'Daily Return (%)'
        },
        labels: {
          formatter: (value) => value.toFixed(1) + '%'
        }
      },
      tooltip: {
        x: {
          format: 'dd MMM yyyy'
        },
        y: {
          formatter: (value) => {
            const sign = value >= 0 ? '+' : '';
            return sign + value.toFixed(2) + '%';
          }
        }
      },
      annotations: {
        yaxis: [{
          y: 0,
          borderColor: colors.grid || '#999',
          strokeDashArray: 0
        }]
      }
    };

    return {
      componentOptions: options,
      series: [{
        name: 'Daily Return',
        data: data.map(d => ({ x: d.x, y: d.y }))
      }]
    };
  }, [returnsSeries, height, colors]);

  if (!componentOptions) {
    return (
      <div className="flex items-center justify-center text-base-content/60" style={{ height }}>
        No returns data available
      </div>
    );
  }

  return (
    <div>
      <h4 className="text-sm font-bold mb-2">Daily Returns</h4>
      <OptimizedChart
        componentOptions={componentOptions}
        series={series}
        type="bar"
        height={height}
      />
    </div>
  );
};

export default DailyReturnsChart;
